import React from 'react'
import { useLocation, useNavigate } from 'react-router'
import pluralize from 'pluralize'
import { Button } from '@demandlocal/components'
import { ReactComponent as IconPendingClock } from '../../../images/icons/icon_pending_clock.svg'
import { ReactComponent as CampaignImportSuccessIcon } from '../../../images/campaign_import_success.svg'
import { useDealership } from '../../../store/zustand/dealershipStore'
import { useTranslation } from 'react-i18next'
export default function CampaignImportSuccess() {
  const dealership = useDealership()
  const { t } = useTranslation('routes')
  const location = useLocation()
  const navigate = useNavigate()
  const {
    campaign_count = 1,
  }: {
    campaign_count: number
  } = location.state || {}
  return (
    <div className={'flex flex-1 flex-col h-screen'}>
      <div
        className={
          'h-full overflow-auto flex flex-col items-center justify-center gap-10'
        }>
        <CampaignImportSuccessIcon />
        <div className={'text-3xl font-bold text-primary-xiketic'}>
          Nice! You have imported {pluralize('campaign', campaign_count, true)}{' '}
          successfully.
        </div>
        <div
          className={
            'max-w-md bg-secondary-sunglow/20 p-3 font-regular gap-4 flex flex-row items-center rounded-md'
          }>
          <IconPendingClock className={'w-12 h-12'} />
          <p>
            Your {pluralize('campaign', campaign_count)} will be available in a few
            minutes.{' '}
            <span className={'font-bold'}>
              Data is being processed and will be available shortly.
            </span>
          </p>
        </div>
        <div>
          <Button
            variant={'rainbow'}
            onClick={(e) => {
              e.preventDefault()
              navigate(t('dealership.campaigns.self-service.list', { dealership }))
            }}>
            See Campaigns
          </Button>
        </div>
      </div>
    </div>
  )
}
